import { baseService } from "src/store/base.store";
import { WithdrawalRequest } from "./types/withdrawal-request.entity";
import { executeQuery, GenericQueryReturnType } from "src/store";
import { withdrawalRequestRepository } from "./repositories/withdrawal-requests.repository";
import { callFunctionSafe } from "src/firebase/functions";
import { getDownloadURL, ref } from "firebase/storage";
import { InvoiceStorage } from "src/firebase";
import { userRepository } from "../users/repositories/user.repository";

export const findWithdrawalRequestInvoicePdf = async (
  id: string
): Promise<GenericQueryReturnType<"invoice", string>> => {
  try {
    const withdrawalRequest = await withdrawalRequestRepository.findById(id)!;
    const pdfFileName = withdrawalRequest?.userId + "_" + withdrawalRequest?.id;
    const pdfLink = pdfFileName + ".pdf";
    const file = await getDownloadURL(ref(InvoiceStorage, pdfLink));

    return {
      data: {
        invoice: file,
      },
    };
  } catch (_) {
    console.log(_);
    return {
      error: true,
    };
  }
};

export const withdrawalRequestService = baseService.injectEndpoints({
  endpoints: (builder) => ({
    getWithdrawalRequests: builder.query<WithdrawalRequest[], { where?: any; offset?: string }>({
      queryFn: async ({ where = {}, offset }) =>
        executeQuery(async () => {
          const withdrawalRequests = await withdrawalRequestRepository.find({
            where,
            offset,
            orderBy: ["createdAt", "desc"],
          });
          const withdrawalWithUsers = await Promise.all(
            withdrawalRequests.map(async (request) => {
              const user = await userRepository.findById(request.userId);
              return {
                ...request,
                user,
              };
            })
          );
          return withdrawalWithUsers;
        }),
      providesTags: ["WithdrawalRequest"],
    }),
    countWithdrawalRequests: builder.query<number, void>({
      queryFn: async () => executeQuery(() => withdrawalRequestRepository.count()),
    }),
    processWithdrawalRequest: builder.mutation<void, { id: string; action: "APPROVE" | "REJECT" }>({
      queryFn: async ({ id, action }) =>
        callFunctionSafe("processWithdrawalRequestAction", { withdrawalRequestId: id, action: action }),
      invalidatesTags: ["WithdrawalRequest"],
    }),
    getInvoicePdf: builder.query<{ invoice: string }, string>({
      queryFn: async (id) => await findWithdrawalRequestInvoicePdf(id),
    }),
  }),
});

export const {
  useGetWithdrawalRequestsQuery,
  useCountWithdrawalRequestsQuery,
  useProcessWithdrawalRequestMutation,
  useGetInvoicePdfQuery,
} = withdrawalRequestService;
